export default __webpack_public_path__ + "static/media/treso-esg.3d514591.jpg";